/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var createAnimation = require('lib/util/createAnimation').createAnimation;

(function ($, Module, SCS, debug) {
	'use strict';

	// Helper functions

	// Object.create polyfill (without getter/setter support)
	var createObject = Object.create || function (proto) {
			// Inherit from “Item”
			function Creator() {
			}

			Creator.prototype = proto;
			return new Creator();
		};

	// Data structure to hold jQuery objects
	function NodeWrapper($ctx) {
		this.$ctx = $ctx;
	}

	function updateStepBackState(topic, active) {
		topic.$ctx.find('.step-back').toggleClass('is-hidden', !active);
		topic.$ctx.toggleClass('last', active);
	}

	// Set the current and active states.
	// An item that is current is, by definition, always active
	// What being current or being active means differs by type.
	// Steps:
	//		Steps are active if they are visible and current if a topic has been clicked
	//		Multiple Steps can be current at a time.
	//		If steps 1…n are current, steps 1…n+1 are active
	// Topics:
	//		A topic is current if it has been clicked upon.
	//		Active means a topic’s parent is current
	//		One topic per step can be current
	NodeWrapper.prototype.updateState = function (current, active) {
		if (current !== null) {
			this.$ctx.toggleClass('current', current);
			if (current) {
				active = true;
			}
		}
		if (active !== null) {
			this.$ctx.toggleClass('active', active);
		}

		var isMobilePage = SCS.utils.isMobilePage();
		if (isMobilePage) {
			if (!current) {
				updateStepBackState(this, false);
				if (this.parent && this.parent.$ctx.hasClass('current')) {
					updateStepBackState(this.parent, true);
				}
			} else {
				updateStepBackState(this, true);
				if (this.parent) {
					updateStepBackState(this.parent, false);
				}
			}
		}
	};
	NodeWrapper.prototype.getContext = function () {
		return this.$ctx;
	};

	// Represents a whole step
	function Step($ctx, previousStep, module) {
		NodeWrapper.call(this, $ctx);
		this.nextStep = null;
		this.number = $ctx.data('stepNumber');
		this.topics = [];
		this.results = [];
		this.topicsByName = {};
		this.selectedTopic = null;
		this.module = module;
		this.previousStep = previousStep;
		if (previousStep) {
			previousStep.nextStep = this;
		}
	}

	Step.prototype = createObject(NodeWrapper.prototype);

	Step.prototype.namedTopic = function (topicName) {
		return this.topicsByName[topicName];
	};

	Step.prototype.addTopic = function (topic) {
		this.topics.push(topic);
		this.topicsByName[topic.name] = topic;
		topic.setStep(this);
	};

	Step.prototype.addResult = function (result) {
		this.results.push(result);
		result.setStep(this);
	};

	Step.prototype.updateItems = function (current, active) {
		$.each(this.topics, function () {
			this.updateState(current, active);
		});
		$.each(this.results, function () {
			this.updateState(current, active);
		});
	};

	Step.prototype.deselect = function () {
		if (!this.selectedTopic) {
			return;
		}

		var newTopic = (this.previousStep && this.previousStep.selectedTopic) || null;

		this.selectTopic(newTopic);
	};

	// Select a new topic. Call this on the lowest step that must be updated.
	// Hash handling will call this on the first step,
	// click handlers on the step the click ocurred.
	Step.prototype.selectTopic = function (topic) {
		// Search parents of the newly-selected topic until we found one in our step (like jQuery.fn.closest)
		var stepTopic = topic;

		while (stepTopic && stepTopic.step !== this) {
			stepTopic = stepTopic.parent;
		}

		debug.log('Tc.Module.ContactWizard > Step > selecting step topic', stepTopic, stepTopic === topic, 'in step', this.number);

		// Mark the step topic as selected
		this.selectedTopic = stepTopic;

		// Set current if we have a “current” topic for this step
		this.updateState(!!stepTopic, null);

		// Remove “current” from all items
		this.updateItems(false, null);
		// Mark current item active (if any)
		if (stepTopic) {
			stepTopic.updateState(true, null);
		}

		// Propagate to the next step (if any)
		if (this.nextStep) {
			this.nextStep.markActive(stepTopic);
			this.nextStep.selectTopic(topic);
		} else {
			// Mark topic as selected in the module (for hash handling, scrolling and stuff)
			this.module.topicSelected(topic);
		}
	};

	Step.prototype.markActive = function (parentTopic) {
		var activeItems = [];
		if (parentTopic) {
			// Mark which subset of topics/results are active (the ones whose parent are from the previous step)
			activeItems = parentTopic.children;
		}

		debug.log('Tc.Module.ContactWizard > Step > activating children from', parentTopic, ':', activeItems, 'in step', this.number);

		// Deactivate all items
		this.updateItems(false, false);

		// Activate active items
		$.each(activeItems, function () {
			this.updateState(null, true);
		});

		// Set step active if we have topics to show in this step
		this.updateState(null, !!activeItems.length);
	};

	// Represents a topic or a result
	function Item($ctx) {
		NodeWrapper.call(this, $ctx);
		this.parentTopicName = $ctx.data('parentTopic');
		this.step = null;
		this.parent = null;
		this.children = [];
		this.init();
	}

	Item.prototype = createObject(NodeWrapper.prototype);

	Item.prototype.init = function () {
	};

	Item.prototype.setStep = function (step) {
		this.step = step;
		if (this.step.previousStep) {
			var parent = this.step.previousStep.namedTopic(this.parentTopicName);
			if (parent) {
				this.setParent(parent);
			}
		}
	};

	Item.prototype.setParent = function (parent) {
		this.parent = parent;
		parent.children.push(this);
	};

	// Represents a topic or subtopic that can be clicked on
	function Topic($ctx) {
		Item.call(this, $ctx);
		this.name = this.$ctx.data('name');
		this.mobileResultLink = this.$ctx.data('mobileResultLink');
	}

	Topic.prototype = createObject(Item.prototype);

	Topic.prototype.init = function () {
		this.$ctx.on('click tap', $.proxy(this.select, this));
		this.$ctx.find('.step-back > a').on('click tap', this.deselect.bind(this));
	};

	Topic.prototype.deselect = function (evt) {
		evt.preventDefault();
		evt.stopPropagation();
		updateStepBackState(this, false);
		this.step.deselect();
	};

	Topic.prototype.select = function () {
		this.step.selectTopic(this);
	};

	Topic.prototype.getTitle = function () {
		return this.$ctx.find('.title').text();
	};

	// Represents a result
	function Result($ctx) {
		Item.call(this, $ctx);

	}

	Result.prototype = createObject(Item.prototype);

	Result.prototype.updateState = function (current, active) {
		Item.prototype.updateState.apply(this, arguments);
		if (active) {
			SCS.utils.initNewModules(this.$ctx);
		}
	};

	/**
	 * Module for the Contact Wizard
	 *
	 * @author Benjamin Berger, Raphael Schweikert
	 * @namespace Tc.Module
	 * @class ContactWizard
	 * @extends Tc.Module
	 * @version 1.0
	 */
	Module.ContactWizard = Module.extend({
		// Whether we are curently editing page the component is on
		isEditMode: false,
		// Whether we are in mobile view
		isMobilePage: false,
		// All the steps in this contact wizard
		steps: null,
		// Whether debug mode is on
		debug: false,
		// The initial document title
		defaultTitle: null,
		// The animator for scrolls
		scrollAnimation: null,

		/**
		 * Main function.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			// Module vars
			this.isEditMode = !!$('.cq_isEditMode').length;
			this.isMobilePage = SCS.utils.isMobilePage();
			this.steps = [];
			this.debug = !!(window.location.search + window.location.hash).match(/\bdevconsole\b/);
			if (this.debug) {
				window.modContactWizard = this;
			}

			callback();
		},

		/**
		 * Initialize contact wizard functionality.
		 */
		after: function () {
			// Find steps and topics
			this.initializeSteps();
			this.loadStateFromHash();
			this.initializeDom();
			// Load initial hash
			this.hashChanged();
		},

		initializeSteps: function () {
			var mod = this;
			var $steps = this.$ctx.find('> .steps > .step');
			var previousStep = null;
			$steps.each(function () {
				var $step = $(this);
				var step = new Step($step, previousStep, mod);
				mod.steps.push(step);

				// Handle topics
				var $topics = $step.find('.topics > .topic');
				$topics.each(function () {
					var $topic = $(this);
					var topic = new Topic($topic);
					step.addTopic(topic);
				});
				debug.log('Tc.Module.ContactWizard > found topics', $topics);

				// Handle results
				var $results = $step.find('.results > .result');
				$results.each(function () {
					var $result = $(this);
					var result = new Result($result);
					step.addResult(result);
				});
				debug.log('Tc.Module.ContactWizard > found results', $results);

				// Handle the reset button
				var $reset = $step.find('.show-all');
				if ($reset.length) {
					$reset.on('click tap', function (event) {
						event.preventDefault();
						step.deselect();
					});
				}
				previousStep = step;
			});
		},

		initializeDom: function () {
			var $window = $(window);
			// Bind hash change handlers
			$window.on('hashchange', $.proxy(this.hashChanged, this));
			// Store initial document title
			this.defaultTitle = Module.ContactWizard.titleGetter();
			// Create animator
			this.scrollAnimation = createAnimation({
				easing: $.easing.swing,
				animator: function (time, scrollTop) {
					$window.scrollTop(scrollTop);
				},
				startValueCalculator: function () {
					return $window.scrollTop();
				}
			});
		},

		// Scroll to the next step when we have selected a topic
		scrollToTopic: function (topic) {
			if (!topic) {
				return;
			}
			var step = topic.step;
			if (!step) {
				return;
			}
			// Only scroll to the current step on mobile since the items collapse anyway and we don’t know their height before they do, yielding an incorrect scroll position.
			// Also scrolling to the next step would hide the “show all” button that only just appeared…
			if (!this.isMobilePage) {
				step = step.nextStep;
			}
			if (!step) {
				return;
			}
			var pos = step.getContext().offset();
			if (!pos) {
				return;
			}

			var correctionElement = this.$ctx.parents('body').find('.modHeader .scsh-lvl2-container'),
				correction = 0;

			if (correctionElement.length) {
				correction = correctionElement.height() + 10;
			}

			debug.log('Tc.Module.ContactWizard > scrolling to', pos);
			this.scrollAnimation.start({
				endValue: pos.top - correction
			});
		},

		// Hash serialziation
		setHash: function (hash) {
			if (this.currentHash === hash) {
				return;
			}
			debug.log('Tc.Module.ContactWizard > setting hash to', hash);
			this.currentHash = hash;
			Module.ContactWizard.hashSetter(hash || '');
		},

		topicSelected: function (topic) {
			var hash = (topic && topic.name) || null;
			this.trackSelectionChange(topic);
			this.updateTitle(topic);
			this.setHash(hash);
			this.scrollToTopic(topic);
			if (topic && this.isMobilePage && topic.mobileResultLink) {
				document.location.replace(topic.mobileResultLink);
			}
			this.fire('topicSelected', topic);
		},

		// Hash deserialziation
		getHash: function () {
			var hash = Module.ContactWizard.hashGetter() || '';
			if (hash.charAt(0) === '#') {
				hash = hash.substring(1);
			}
			if (hash === this.currentHash) {
				// Same hash has already been set, do nothing
				return null;
			}
			debug.log('Tc.Module.ContactWizard > got changed hash', hash);
			return hash;
		},

		loadStateFromHash: function (hash) {
			if (hash === null) {
				return;
			}

			if (!this.steps || !this.steps.length) {
				return;
			}

			var topic = null;

			// Find topic by name
			for (var i = 0; i < this.steps.length && !topic; i += 1) {
				topic = this.steps[i].namedTopic(hash);
			}

			if (topic) {
				this.currentHash = hash;
				this.steps[0].selectTopic(topic);
			} else if (!hash) {
				this.steps[0].deselect();
			}
		},

		// @VisibleForTesting
		hashChanged: function () {
			var hash = this.getHash();
			this.loadStateFromHash(hash);
		},

		// Change the document title to match the topic
		updateTitle: function (topic) {
			var titles = [];

			while (topic) {
				titles.unshift(topic.getTitle());
				topic = topic.parent;
			}

			var newTitle = this.defaultTitle;
			if (titles.length) {
				newTitle = titles.join(': ') + ' – ' + newTitle;
			}
			debug.log('Tc.Module.ContactWizard > updating title to', newTitle);
			Module.ContactWizard.titleSetter(newTitle);
		},

		// perform click tracking on selection change
		trackSelectionChange: function (topic) {
			if (!topic) {
				return;
			}
			debug.log('Tc.Module.ContactWizard > trackSelectionChange >', topic);
			var label = topic.name || '', // currently selected button with top category prefix
				category = topic.parentTopicName || topic.name; // selected top category (or if already top category the topic itself)

			SCS.portal.datalayer.trackEvent('select', label, 'contactform', category, 'Contact Wizard');
		}
	});

	// All of these are mocked in testing
	$.extend(Module.ContactWizard, {
		hashSetter: function (hash) {
			window.location.hash = hash;
		},
		hashGetter: function () {
			return window.location.hash;
		},

		titleSetter: function (title) {
			document.title = title;
		},
		titleGetter: function () {
			return document.title;
		}
	});

})(window.Tc.$, window.Tc.Module, window.SCS, window.debug || window.console);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/shared/js/modules/Tc.Module.ContactWizard.js
// module id = 351
// module chunks = 0